export const API_BASE_URL = import.meta.env.VITE_API_URL ?? 'https://api.urbanlife.works';
export const PLATFORM_ORIGIN = 'https://urbanlife.works';
export const IS_EMBEDDED = new URLSearchParams(window.location.search).get('embed') === 'true';
export const STARTING_CASH = 100_000; // paper trading starting balance
